module.exports = __webpack_public_path__ + "img/icon_download.4c8f9f97.svg";